import { DEBUG } from "../../../config";
import React, { FC, memo, useState, useEffect, useCallback, useMemo } from "../../../lib/teact/teact";


import Avatar from "../../common/Avatar";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import ConfirmDialog from "../../ui/ConfirmDialog";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import TabList from "../../ui/TabList";
import ErrorViewer from "../admin/ErrorViewer";
import { LotScreenSettings } from "../config/uiconfig";
import ParserSettings from "../contact/parserSettings";
import { globalDexieDb } from "../db/DexiedbLib";

import { DBManager } from "../db/dbManager";
import { IDBMessage } from "../db/model/dbMessage";
import { DownloadAllContactGiaThuong } from "../db/repository/contactRepo";
import { AdminApi } from "../restapi/adminApi";
import { ContactsApi } from "../restapi/contactsApi";
import { TongHopReport } from "../restapi/tongHopReport";
import store from "../store";
import LotSpinner from "../ui/LotSpinner";
import '../ui/formCommon.scss'
import Loading from "../ui/loading";
import LotLoading from "../ui/loading";
import Snackbar from "../ui/snackbar";
import { getDateTimeString, secondsToDateString } from "../utils/DateTimeUtils";
import { GetMienCuPhapID, GetUserFullInfo, GetUserID, isCuPhapMn } from "../utils/common";

import TuKhoaRieng from "./TuKhoaRieng";
import UserDaiConfig from "./userDaiConfig";
type OwerProp = {
    tinhId: string;
    onChangeScreen: (screen: LotScreenSettings) => void;
}
const globalConfigChanged: string = "globalConfigChanged"
const GlobalSetting: FC<OwerProp> = ({
    tinhId,
    onChangeScreen,
}) => {
    const fullUser = useMemo(() => GetUserFullInfo(), []);
    //const dataChanged = localStorage[globalConfigChanged];
    const indexTuKhoa = isCuPhapMn() ? 2 : 1
    const indexTaikhoan = isCuPhapMn() ? 3 : 2
    const indexLoginttele = isCuPhapMn() ? 4 : 3
    const TABS = (isCuPhapMn() ? [
        { type: 'ParserParam', title: 'Tham số' },
        { type: 'daiSettting', title: 'Đài xổ/tuần' },
        { type: 'tuKhoaRieng', title: 'Từ khoá đặc biệt' },
        { type: 'taiKhoan', title: 'Tài khoản' },
        { type: 'loginttele', title: 'Tele Cloud' },
    ]
        : [{ type: 'ParserParam', title: 'Tham số' },
        { type: 'tuKhoaRieng', title: 'Từ khoá đặc biệt' },
        { type: 'taiKhoan', title: 'Tài khoản' },
        { type: 'loginttele', title: 'Tele Cloud' },
        ]
    )



    const prevScreen = store.getState().login.prevScreen
    const [state, setState] = useState({
        activeTab: 0,
        curTinh: tinhId,
        showDefaultDialog: false,
        dmTinh: [],
        mienDaiCuoc: 3,
        showSnackbar: false,
        snackbarMessage: "",
        dataChanged: false,
        trigger: "",
        isLoading: false,
        isSyncing: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        showErrorLog: false,
        showDialogPredef: false,
    })
    const [, updateState] = useState();
    function handleDataChange() {
        setState(prev => ({ ...prev, dataChanged: true }))
        localStorage[globalConfigChanged] = true;
    }
    function handleTinhIdChange(tinhId: string) {
        localStorage["tinhId"] = tinhId;
        const oldTab = state.mienDaiCuoc;
        let newTab = oldTab
        if (oldTab == 3)
            newTab = 2;
        if (oldTab == 2)
            newTab = 3;

        setState(prev => ({
            ...prev, curTinh: tinhId, trigger: JSON.stringify(new Date()),
            isLoading: true
        }))
        console.log(`mien dai cuoc nhay di:${newTab}`)
        const timerId = setTimeout(() => {
            setState(prev => ({ ...prev, isLoading: false })) // nhảy lại tab cũ, bực thật
            console.log(`mien dai cuoc nhay lai:${oldTab}`)
            clearTimeout(timerId);
        }, 200)
        handleDataChange()
        localStorage[globalConfigChanged] = true;
        console.log(`thay doi vung cu phap:${tinhId}`)
        forceUpdate()
    }
    useEffect(() => {
        DBManager.getDBConnection().then(db => {
            const getRequest = db.transaction("dmTinh")
                .objectStore("dmTinh")
                .getAll();
            const tmp: any[] = [];
            getRequest.onsuccess = () => {
                getRequest.result.map((item) => {
                    tmp.push(item)
                })
                setState((prev: any) => ({ ...prev, dmTinh: tmp }))
            }
        })
    }, [])
    function readDataFromIndexedDB() {
        return new Promise((resolve, reject) => {
            const request = DBManager.getDBConnection().then(db => {
                const transaction = db.transaction(['userConfig', 'userDaiConfig', 'tuKhoaRieng'], 'readonly');
                const objectStore1 = transaction.objectStore('userConfig');
                const objectStore2 = transaction.objectStore('userDaiConfig');
                const objTuKhoa = transaction.objectStore('tuKhoaRieng');

                const getObjectStoreData = (objectStore: any) => {
                    return new Promise((resolve, reject) => {
                        const data: any[] = [];
                        objectStore.openCursor().onsuccess = (event: Event) => {
                            const cursor = event!.target.result;
                            if (cursor) {
                                data.push(cursor.value);
                                cursor.continue();
                            } else {
                                resolve(data);
                            }
                        };
                    });
                };
                const userId = Number(GetUserID())
                const getDaiGioChot = () => globalDexieDb.daiGioChot.where("userId").equals(userId).toArray()
                Promise.all([
                    getObjectStoreData(objectStore1),
                    getObjectStoreData(objectStore2),
                    getObjectStoreData(objTuKhoa),
                    getDaiGioChot(),
                ]).then(([userConfig, userDaiConfig, tuKHoaRieng, daiGioChot]) => {
                    const result = {
                        userConfig: userConfig,
                        userDaiConfig: userDaiConfig,
                        tuKHoaRieng: tuKHoaRieng,
                        daiGioChot: daiGioChot,
                    };
                    resolve(result);
                });
            })

        });
    }
    async function handleSaveData() {
        readDataFromIndexedDB().then(async (payload: any) => {
            payload.tinhId = localStorage["tinhId"]
            payload.mienCuPhapId = Number(localStorage["mienCuPhapId"])
            if (DEBUG) {
                const found = payload.userConfig.find((item: any) => item.tinhId == payload.tinhId)
                if (found) {
                    console.log("userConfig", found)
                }
            }
            const result = await ContactsApi.postUserConfig(payload)

            if (result.errorCode == 0) {
                setState((prev) => ({ ...prev, dataChanged: false }))
                localStorage[globalConfigChanged] = false;
            }
            setState(prev => {
                return {
                    ...prev,
                    showSnackbar: true,
                    snackbarMessage: result.responseText,
                }
            })
        })

    }
    function showDialogPredef() {
        setState((prev) => ({ ...prev, showDialogPredef: true }))
    }
    function closeDialogPredef() {
        setState((prev) => ({ ...prev, showDialogPredef: false }))
    }
    async function handleSaveDataPredef() {
        readDataFromIndexedDB().then(async (payload: any) => {
            payload.tinhId = localStorage["tinhId"]
            payload.mienCuPhapId = Number(localStorage["mienCuPhapId"])
            if (DEBUG) {
                const found = payload.userConfig.find((item: any) => item.tinhId == payload.tinhId)
                if (found) {
                    console.log("userConfig", found)
                }
            }
            const result = await ContactsApi.postUserConfigPredef(payload)

            if (result.errorCode == 0) {
                setState((prev) => ({ ...prev, dataChanged: false }))
                localStorage[globalConfigChanged] = false;
            }
            setState(prev => {
                return {
                    ...prev,
                    showSnackbar: true,
                    snackbarMessage: result.responseText,
                }
            })
        })

    }
    async function handleSaveDataTuKhoaRieng() {
        handleSaveData()
    }
    function handleTabChange(index: number) {
        if (index == 0)
            setState({ ...state, mienDaiCuoc: 3 })
        else
            setState({ ...state, mienDaiCuoc: 2 })

    }
    function handleDefaultParam() {
        setState((prev) => ({ ...prev, showDefaultDialog: false, isLoading: true }))
        //
        DBManager.getDBConnection().then((db) => {
            const trans = db.transaction(["contactsConfigPredef", "userDaiConfigPredef",
                "userConfig", "userDaiConfig"], "readwrite")

            const getUserDaiConfig = trans.objectStore("userDaiConfigPredef").getAll()
            getUserDaiConfig.onsuccess = () => {
                const result = getUserDaiConfig.result;
                const obj = trans.objectStore("userDaiConfig")
                result.map((item) => {
                    if (item.tinhId == state.curTinh) {
                        item = { ...item, userId: Number(localStorage["userId"]) }
                        obj.put(item)
                    }
                })
            }//
            const getParserConfig = trans.objectStore("contactsConfigPredef").get(state.curTinh)
            getParserConfig.onsuccess = () => {
                const result = getParserConfig.result;
                const obj = trans.objectStore("userConfig")
                const item = { ...result, userId: Number(localStorage["userId"]) }
                obj.put(item)
            }
            trans.oncomplete = () => {
                const timerId = setTimeout(() => {
                    setState(prev => ({ ...prev, isLoading: false })) // nhảy lại tab cũ, bực thật

                    clearTimeout(timerId);
                }, 200)
            }

        }
        )
    }
    const forceUpdate = useCallback(() => {
        setState(prev => ({ ...prev }))
        updateState({})

    }
        , [])
    function handleChangePassword() {
        const payload = { oldPassword: state.oldPassword, newPassword: state.newPassword }
        if (state.newPassword !== state.confirmPassword) {
            showSnackbar("mật khẩu không khớp")
            return
        }
        AdminApi.ChangePassword(payload).then(res => {
            showSnackbar(res.responseText)
        })
    }
    function showSnackbar(message: string) {
        setState(prev => ({ ...prev, snackbarMessage: message, showSnackbar: true }))
    }

    function handleShowErrorLog() {
        setState(prev => ({ ...prev, showErrorLog: true }))
    }
    function handleErrorDialogClose() {
        setState(prev => ({ ...prev, showErrorLog: false }))

    }

    function dongBoTinNhan() {
        setState(prev => ({ ...prev, isSyncing: true }))

        const ngay = store.getState().global.workDate
        showSnackbar(`Đang đồng bộ tin nhắn ngày ${ngay} vui lòng chờ`)
        globalDexieDb.dbmessages.where('date').equals(ngay).delete()
        TongHopReport.FetchDongBoTinNhan(ngay).then(result => {
            const msgs = result.data
            const dtls = result.dataEx
            let soTin = 0
            let chiTiet = 0
            let thongBao = ''

            if (msgs) {
                for (let i = 0; i < msgs.length; i++) {
                    const item: IDBMessage = msgs[i];
                    item.date = item.date?.substring(0, 10)
                }
                globalDexieDb.dbmessages.bulkPut(msgs)
                soTin = msgs.length;
            }
            if (dtls) {

                globalDexieDb.messageDetails.bulkPut(dtls)
                chiTiet = dtls.length;
            }
            setState(prev => ({ ...prev, isSyncing: false }))
            thongBao = `Đồng bộ xong: ${soTin} tin, ${chiTiet} bản ghi.`
            showSnackbar(thongBao)
        })
    }
    const mienCuPhapId = GetMienCuPhapID()
    function getIframeUrl() {
        const { protocol, hostname } = window.location;
        let url = `https://${hostname}/logintele`;
        if (window.location.href.indexOf("localhost") >= 0) {
            url = "http://localhost:5173"
        }
        console.log("iframe url:", url)
        return url
    }
    return (
        <div className='form-main'>
            <div className="form-header">
                <div className="form-header left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => onChangeScreen(prevScreen)}

                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>

                    <div>Cài đặt tham số hệ thống</div>
                </div>

                <div className="form-header right-panel">
                    {(fullUser.username == "admin" || fullUser.username == "hoangsg" )&&

                        <Button
                            onClick={showDialogPredef}
                            round
                            size="default"
                            color="translucent" >
                            <i className={state.dataChanged == true ? "fa-regular fa-floppy-disk fa-xl fa-beat" : "fa-regular fa-floppy-disk fa-xl"}
                                style={'color:red'}></i>

                        </Button>


                    }
                    <Button
                        onClick={handleSaveData}
                        round
                        size="default"
                        color="translucent" >
                        <i className={state.dataChanged == true ? "fa-regular fa-floppy-disk fa-xl fa-beat" : "fa-regular fa-floppy-disk fa-xl"}></i>
                    </Button>

                </div>
            </div>
            <div className="form-content">
                <div className="contact-config-header">
                    <div className='contact-config-header left-panel'>
                        <div className="contact-cai-dat-tinh">
                            <div >Sử dụng cú pháp vùng</div>
                            <select className="custom-select" value={state.curTinh}
                                onChange={(e) => handleTinhIdChange(e.target.value)}
                            >
                                {
                                    state.dmTinh.filter((it: any) => it.mienCuPhapId == mienCuPhapId).map((item: any, index) => {
                                        return <option value={item.tinhId} selected={state.curTinh == item.tinhId} >{item.tenTinh}</option>
                                    })
                                }
                            </select>
                        </div>
                        <Button round
                            size="default"
                            color="translucent"
                            onClick={() => { setState({ ...state, showDefaultDialog: true }) }}
                        >
                            <i className="fa-solid fa-tent-arrows-down"></i>

                        </Button>
                    </div>
                </div>
                <TabList tabs={TABS} activeTab={state.activeTab}
                    onSwitchTab={(index) => { setState((prev) => ({ ...prev, activeTab: index })) }} />
                {
                    state.activeTab == 0 && state.isLoading && <LotLoading />
                }
                {
                    state.activeTab == 0 && !state.isLoading &&

                    <ParserSettings tinhIdProp={state.curTinh}
                        isGlobalConfig={true}
                        onDataChange={handleDataChange}
                        headerCount={3}
                        showMyHeader={false}
                        trigger={JSON.stringify(new Date())}
                    />
                }
                {
                    state.activeTab == 1 && !state.isLoading && isCuPhapMn() &&
                    <UserDaiConfig
                        forceUpdate={forceUpdate}
                        onTabChange={handleTabChange}
                        onDataChange={handleDataChange}
                        mienDaiCuoc={state.mienDaiCuoc}
                        tinhId={state.curTinh}
                        trigger={state.trigger} />
                }
                {
                    state.activeTab == 1 && state.isLoading && isCuPhapMn() && <LotLoading />
                }
                {
                    state.activeTab == indexTuKhoa &&
                    <TuKhoaRieng onSaveData={handleSaveDataTuKhoaRieng} />
                }

                {
                    state.activeTab == indexTaikhoan &&
                    <div className="account-main">
                        <div className='contact-config-section-item'>
                            <div className="contact-config-section-header">thay đổi mật khẩu</div>
                            <div className='change-password-section'>
                                <label htmlFor='password'>Mật khẩu cũ</label>
                                <input className='lot-input w80' id='password' type='password' placeholder=' '
                                    value={state.oldPassword}
                                    onChange={(e) => {
                                        setState(prev => ({ ...prev, oldPassword: e.target.value }))
                                    }} />
                                <label htmlFor='password1'>Mật khẩu mới</label>
                                <input className='lot-input w80' id='password1' type='password' placeholder=' '
                                    value={state.newPassword}
                                    onChange={(e) => {
                                        setState(prev => ({ ...prev, newPassword: e.target.value }))
                                    }} />
                                <label htmlFor='password2'>Nhập lại Mật khẩu mới</label>
                                <input className='lot-input w80' id='password2' type='password' placeholder=''
                                    value={state.confirmPassword}
                                    onChange={(e) => {
                                        setState(prev => ({ ...prev, confirmPassword: e.target.value }))
                                    }} />
                                <div className='change-password-section button'>
                                    <Button size="smaller" color='primary'
                                        onClick={handleChangePassword}
                                    >
                                        <span>Đổi mật khẩu</span>
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <div className="contact-config-section-header">Lựa chọn lưu số liệu</div>
                        <Checkbox label="Lưu số liệu cục bộ"
                            checked={localStorage["localMode"] == 1}
                            subLabel='Toàn bộ số liệu phân tích sẽ được lưu trên trình duyệt, tiết kiệm băng thông mạng, cải thiện tốc độ'
                            onChange={(e) => {
                                if (e.target.checked) {
                                    if (localStorage["localMode"] == 0) {
                                        showSnackbar("Đang tải dữ liệu liên quan, vui lòng chờ...")
                                    }
                                    localStorage["localMode"] = 1

                                    DownloadAllContactGiaThuong().then((res: any) => {
                                        showSnackbar(res.responseText)
                                    })
                                } else
                                    localStorage["localMode"] = 0
                            }} />
                        <div style='width:100%;align-items:center; justify-items:center;display:flex;flex-direction:column;'>
                            <div style='width:200px;'>
                                {state.isSyncing
                                    ? <Loading />
                                    : <Button size="tiny" disabled={localStorage["localMode"] != 1}
                                        onClick={() => dongBoTinNhan()}
                                    >
                                        Đồng bộ tin nhắn
                                    </Button>
                                }
                            </div>
                        </div>
                        <div style="width:200px;">
                            <Button
                                onClick={handleShowErrorLog}
                                color="secondary"
                                size="smaller"
                                style='text-transform: lowercase;'
                            >

                                Xem lịch sử lỗi
                            </Button>
                        </div>

                    </div>
                }
                {
                    state.activeTab == indexLoginttele &&
                    <a
                        href={getIframeUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'block', width: '100%', height: '600px', border: '1px solid #ccc', textAlign: 'center', lineHeight: '600px', textDecoration: 'none', background: '#f9f9f9' }}
                    >
                        👉 Nhấn vào đây để đăng nhập Telegram
                    </a>
                }
            </div>
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarMessage} triggerTime={Date()}
                onClose={() => { setState((prev) => ({ ...prev, showSnackbar: false })) }}
            />
            <ConfirmDialog
                title='Đặt về cài đặt ngầm dịnh'
                text='Bạn có muốn cài đặt tất cả tham số theo tham số ngầm định của hệ thống không?'
                confirmLabel='Đồng ý'
                isOpen={state.showDefaultDialog}
                onClose={() => { setState({ ...state, showDefaultDialog: false }) }}
                confirmHandler={() => { handleDefaultParam() }}
            />
            <ConfirmDialog
                title='Đặt làm tham số ngầm định'
                text='Bạn có muốn lấy tham số này làm tham số ngầm định cho hệ thống không?'
                confirmLabel='Đồng ý'
                isOpen={state.showDialogPredef}
                onClose={closeDialogPredef}
                confirmHandler={() => { closeDialogPredef(); handleSaveDataPredef() }}
            />
            <ErrorViewer isOpen={state.showErrorLog} onClose={handleErrorDialogClose}></ErrorViewer>
        </div>
    )
}
export default memo(GlobalSetting)

function GetFullUserInfo() {
    throw new Error("Function not implemented.");
}
